import type {
  RuntimeResult,
  BatterySizeResult,
  MaxLoadResult,
  PackBuilderResult,
  ChargeTimeResult,
  PassFailResult,
  DischargeCurvePoint,
  CalibrationInput,
  SensitivityResult,
} from '@brt/shared-types'
import type { AppStore } from '../useAppStore.ts'

export interface ResultsSlice {
  runtimeResult: RuntimeResult | null
  batterySizeResult: BatterySizeResult | null
  maxLoadResult: MaxLoadResult | null
  packResult: PackBuilderResult | null
  chargeTimeResult: ChargeTimeResult | null
  passFailResult: PassFailResult | null
  dischargeCurve: DischargeCurvePoint[]
  sensitivityResult: SensitivityResult | null
  calibration: CalibrationInput | null
}

type Set = (fn: (state: AppStore) => Partial<AppStore>) => void

export function createResultsSlice(_set: Set): ResultsSlice {
  return {
    runtimeResult: null,
    batterySizeResult: null,
    maxLoadResult: null,
    packResult: null,
    chargeTimeResult: null,
    passFailResult: null,
    dischargeCurve: [],
    sensitivityResult: null,
    calibration: null,
  }
}
